/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Reconnect_SuccessInputs */



/**
* | output |
* | --- |
* | "Space reconnected. Sync resumed." |
*
* @param {Spaces_Reconnect_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_reconnect_success = /** @type {((inputs?: Spaces_Reconnect_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Reconnect_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Space wurde neu verbunden. Synchronisation fortgesetzt.")
	return /** @type {LocalizedString} */ ("Space reconnected. Sync resumed.")
});